"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Select;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const Label_1 = __importDefault(require("./Label"));
const variables_1 = __importDefault(require("../../styles/variables"));
const useStyles = (0, core_1.makeStyles)({
    select: {
        backgroundColor: variables_1.default.colors.surface.default,
        '&:focus': {
            backgroundColor: 'inherit',
        },
        '&.MuiOutlinedInput-input': {
            padding: '9px 12px',
        },
    },
    baseSelect: {
        borderRadius: '8px',
        borderColor: variables_1.default.colors.border.default,
        '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: variables_1.default.colors.border.active,
        },
    },
    helperText: { color: variables_1.default.colors.text.subdued },
    label: {
        marginBottom: variables_1.default.spacing(0.5),
        lineHeight: variables_1.default.fonts.lineHeight.regular,
    },
});
function Select({ items, label, helperText, value, required, className, multiple, customSelectText, ...rest }) {
    const classes = useStyles();
    const itemsMap = new Map();
    for (const item of items) {
        itemsMap.set(item.id, item);
    }
    const renderValue = (value) => {
        if (multiple && customSelectText) {
            if (value.length === 0) {
                return `Select ${customSelectText}`;
            }
            return `${value.length} ${customSelectText}${value.length > 1 ? 's' : ''} selected`;
        }
        else {
            return itemsMap.get(value)?.name;
        }
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Label_1.default, { label: label, required: required, className: classes.label }),
        react_1.default.createElement(core_1.Select, { IconComponent: icons_1.ExpandMore, fullWidth: true, value: value || '', variant: "outlined", className: classes.baseSelect, "data-testid": "baseSelect", classes: { select: classes.select }, multiple: multiple, displayEmpty: true, renderValue: renderValue, ...rest }, items.map((item) => (react_1.default.createElement(core_1.MenuItem, { key: item.id, value: item.id, disabled: item.disabled },
            multiple && (react_1.default.createElement(core_1.ListItemIcon, null,
                react_1.default.createElement(core_1.Checkbox, { checked: Array.isArray(value) && value.includes(item.id) }))),
            react_1.default.createElement(core_1.ListItemText, null, item.name))))),
        helperText && (react_1.default.createElement(core_1.FormHelperText, { className: classes.helperText, "data-testid": "helperText" }, helperText))));
}
